export default __webpack_public_path__ + "static/images/beam-box@2x.7a04a7a311d82584eb60b9db20b0ab1e.png";